import React from 'react'
import ReactDOM from 'react-dom/client'

import '@digital-twins/deck-ui/slides/index'

// Register SurveyJS Japanese locale so that any SurveyModel instantiated with
// survey.locale = 'ja' gets correctly localized button labels (Next, Complete,
// Required, etc.) in standard modern Japanese (横書き, 丁寧語 register).
// Other locales are bundled by default; Japanese must be explicitly registered.
import 'survey-core/i18n/japanese'

import './globals.css'

import { App } from './App'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
